import { DatePickerValue, DatesRangeValue } from '@mantine/dates';
import { Filter, FilterType } from 'common/repositories/common.model';
import { dateFormated, toISOString } from 'common/utils/date';

export enum DateRangeEnum {
  atAfter = 'after',
  atBefore = 'before',
}

export function replaceAfterLabel(name: string) {
  try {
    return name.replace('After', '');
  } catch {
    return name;
  }
}

export function tagLabelFormatter(filter: Filter) {
  const currentValue =
    filter.options?.find((f) => f.value === filter.value)?.label ||
    filter.value ||
    filter?.default;

  const label = [`${filter.label}:`];

  if (currentValue) {
    if (filter.type === FilterType.Date) {
      if (typeof currentValue === 'string') {
        label.push(dateFormated(new Date(currentValue)));
      } else {
        label.push(dateFormated(currentValue));
      }
    } else {
      label.push(currentValue);
    }
    return label.join(' ');
  }

  return null;
}

export function parseDateFilter(filter: Filter, value?: string) {
  if (value) {
    return new Date(value);
  }
  return filter.value
    ? new Date(filter.value)
    : filter.default
    ? new Date(filter.default)
    : null;
}

export function afterBeforeHandler(
  filterAfter: Filter,
  filters: Filter[],
  _value?: string,
) {
  const filterName = filterAfter.name.replaceAll(DateRangeEnum.atAfter, '');
  const atBeforeName = filterName + DateRangeEnum.atBefore;
  const atBefore = filters.find(
    (filter) => filter.name === filterName + DateRangeEnum.atBefore,
  );
  const atBeforeValue = atBefore ? parseDateFilter(atBefore) : null;
  const atAfterValue = parseDateFilter(filterAfter, _value);
  const value = [atAfterValue, atBeforeValue] as DatePickerValue<'range'>;
  const filterLabel = replaceAfterLabel(filterAfter.label);

  const transformerChange = (val: DatesRangeValue) => {
    const [atAfter, atBefore] = val;

    return {
      atAfter: atAfter ? toISOString(atAfter) : undefined,
      atBefore: atBefore ? toISOString(atBefore) : undefined,
    };
  };

  return {
    value,
    transformerChange,
    atBeforeName,
    atAfterName: filterAfter.name,
    filterLabel,
  };
}

export function afterBeforeLabelFormatter(filters: Filter[]) {
  const label = [] as string[];
  filters
    .map((filter) => {
      return {
        ...filter,
        currentValue:
          filter.options?.find((f) => f.value === filter.value)?.label ||
          filter.value ||
          filter?.default,
      };
    })
    .map((filter) => {
      const currentValue = filter.currentValue;
      if (filter.type === FilterType.Date) {
        if (typeof currentValue === 'string') {
          label.push(dateFormated(new Date(currentValue)));
        }
      }

      return null;
    });
  return `${replaceAfterLabel(filters?.[0]?.label)}: ${label
    .filter(Boolean)
    .join(' - ')}`;
}

export function afterBeforeFilterGroup(filterName: string, filters: Filter[]) {
  return filters.filter((filter) => filter.name.includes(filterName));
}
